import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const AncillaryStyle = styled(Grid)`
  margin: 10px 0 10px 0;
`;
export const FormStyle = styled(Grid)`
  margin: 25px 0 10px 0;
`;
